import React, { useContext, useEffect, useState, useCallback, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Support } from '../Api/Support';
import { Flip, toast } from 'react-toastify';
import { Complain } from '../Api/Complain';
import { Helmet } from 'react-helmet';

export default function HelpSupport() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { setLoad, setLoadColor } = useContext(Context);

    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [complainList, setComplainList] = useState([]);

    /* ================= VIDEO STATES ================= */
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [progress, setProgress] = useState(0);

    const togglePlay = () => {
        if (!videoRef.current) return;

        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const toggleMute = () => {
        if (!videoRef.current) return;
        videoRef.current.muted = !isMuted;
        setIsMuted(!isMuted);
    };

    const handleTimeUpdate = () => {
        const video = videoRef.current;
        if (!video || !video.duration) return;

        const percentage = (video.currentTime / video.duration) * 100;
        setProgress(percentage);
    };

    const handleSeek = (e) => {
        const video = videoRef.current;
        if (!video || !video.duration) return;

        const seekTime = (e.target.value / 100) * video.duration;
        video.currentTime = seekTime;
    };

    useEffect(() => {
        return () => {
            if (videoRef.current) {
                videoRef.current.pause();
            }
        };
    }, []);

    /* ================= FETCH COMPLAINS ================= */
    const handleComplain = useCallback(async () => {
        setLoad(true);
        setLoadColor("#434343");

        let data = {
            username: JSON.parse(localStorage.getItem('userinfo'))?.username
        };

        let res = await Complain(data);

        if (res) {
            if (res.data.status) {
                setComplainList(res.data.data);
            } else {
                toast.error(res.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                });
            }
        }
        setLoad(false);
    }, [setLoad, setLoadColor]);

    useEffect(() => {
        if (pathname === '/helpSupport') {
            handleComplain();
        }
    }, [pathname, handleComplain]);

    return (
        <>
            <Helmet>
                <title>Help and Support | Contact Jantri Team | Matka Jantri</title>
                <meta name="description" content="Get assistance from the MatkaJantri support team." />
            </Helmet>

            <div className='depositContainer'>

                {/* ================= VIDEO SECTION ================= */}
                <div className="video-wrapper">
                    <h2 className="video-title">Video Tutorial</h2>

                    <div className="video-container">
                        <video
                            ref={videoRef}
                            className="custom-video"
                            onTimeUpdate={handleTimeUpdate}
                            playsInline
                            preload="metadata"
                            muted={isMuted}
                            controls
                        >
                            <source src="/videos/VideoTutorial.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    <div className="video-controls">
                        <button onClick={togglePlay} className="control-btn play-btn">
                            {isPlaying ? "Pause" : "Play"}
                        </button>

                        <button onClick={toggleMute} className="control-btn mute-btn">
                            {isMuted ? "Unmute" : "Mute"}
                        </button>
                    </div>

                    <input
                        type="range"
                        className="progress-bar"
                        value={progress}
                        onChange={handleSeek}
                        min="0"
                        max="100"
                    />
                </div>
            </div>

            {/* ================= CSS ================= */}
            <style>{`
               .video-wrapper {
    width: 100%;
    padding: 15px;
    text-align: center;
}

.video-title {
    margin-bottom: 15px;
}

.video-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
}

.custom-video {
    width: 100%;
    height: auto;        /* important */
    display: block;
    border-radius: 12px;
    background: transparent;
}

.video-controls {
    margin-top: 12px;
}

.control-btn {
    padding: 8px 16px;
    margin: 5px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
}

.play-btn {
    background: #28a745;
    color: white;
}

.mute-btn {
    background: #6c757d;
    color: white;
}

.progress-bar {
    width: 100%;
    max-width: 1200px;
    margin-top: 10px;
}

@media (max-width: 768px) {
    .control-btn {
        padding: 6px 12px;
        font-size: 14px;
    }
}


@media (min-width: 768px) {
    .custom-video {
          height: 700px;
    }
}

  












            `}</style>
        </>
    );
}